import { AREA_ROUTES, TOP_LEVEL_ROUTES } from './routes';

/**
 * NOTE:
 * It's important for the 'selected' nav items styling that the `path`, or any route,
 *  starts with an '/'.
 *
 * eg:
 * 	- path: `/${TOP_LEVEL_ROUTES.resources}/${AREA_ROUTES.providers}`
 *  - const TEST_URL = `/test`;
 */

export const HOME_URL = `/`;
export const LOGIN_URL = `/identity/login`;
export const ACCOUNT_ACTIVATION_URL = `/identity/select-role`;

export const RESOURCES_HEADER_NAVIGATION_ITEMS = [
	{
		key: 'resources-providers',
		label: 'Providers',
		isDropdown: false,
		menuItems: undefined,
		isLegacy: false,
		path: `/${TOP_LEVEL_ROUTES.resources}/${AREA_ROUTES.providers}`,
		order: 1,
	},
	{
		key: 'resources-fitness-centers',
		label: 'Fitness Centers',
		isDropdown: false,
		menuItems: undefined,
		isLegacy: false,
		path: `/${TOP_LEVEL_ROUTES.resources}/${AREA_ROUTES.fitnessCenters}`,
		order: 2,
	},
	{
		key: 'resources-members',
		label: 'Members',
		isDropdown: false,
		menuItems: undefined,
		isLegacy: false,
		path: `/${TOP_LEVEL_ROUTES.resources}/${AREA_ROUTES.members}`,
		order: 3,
	},
];

export const JOIN_OUR_NETWORK_HEADER_NAVIGATION_ITEMS = [
	{
		key: 'join-our-network-providers',
		label: 'Providers',
		isDropdown: false,
		menuItems: undefined,
		isLegacy: false,
		path: `/${TOP_LEVEL_ROUTES.joinOurNetwork}/${AREA_ROUTES.providers}`,
		order: 1,
	},
	{
		key: 'join-our-network-fitness-centers',
		label: 'Fitness Centers',
		isDropdown: false,
		menuItems: undefined,
		isLegacy: false,
		path: `/${TOP_LEVEL_ROUTES.joinOurNetwork}/${AREA_ROUTES.fitnessCenters}`,
		order: 2,
	},
];

export const HEADER_NAVIGATION_ITEMS = [
	{
		key: 'home',
		label: 'Home',
		isDropdown: false,
		menuItems: undefined,
		isLegacy: false,
		path: HOME_URL,
		order: 1,
	},
	{
		key: 'features',
		label: 'Features',
		isDropdown: false,
		menuItems: undefined,
		isLegacy: false,
		path: `/${TOP_LEVEL_ROUTES.features}`,
		order: 2,
	},
	{
		key: TOP_LEVEL_ROUTES.resources,
		label: 'Resources',
		isDropdown: true,
		menuItems: RESOURCES_HEADER_NAVIGATION_ITEMS,
		isLegacy: undefined,
		path: undefined, // dropdown
		order: 3,
	},
	{
		key: TOP_LEVEL_ROUTES.joinOurNetwork,
		label: 'Join Our Network',
		isDropdown: true,
		menuItems: JOIN_OUR_NETWORK_HEADER_NAVIGATION_ITEMS,
		isLegacy: undefined,
		path: undefined, // dropdown
		order: 4,
	},
	{
		key: 'contact-us',
		label: 'Contact Us',
		isDropdown: false,
		menuItems: undefined,
		isLegacy: true,
		path: `/ASH/public/Providers/Contact/default.aspx`,
		order: 5,
	},
];

export const FOOTER_ITEMS = {
	contactUs: `/ASH/public/Providers/Contact/default.aspx`,
	privacy: TOP_LEVEL_ROUTES.privacy,
	terms: TOP_LEVEL_ROUTES.termsAndConditions,
	languageServicesRoot:
		'https://www.ashlink.com/ASH/public/Applications/NetworkSearch/LanguageServices.aspx',
};
